import {
	Component,
	Input,
	EventEmitter,
	Output,
	forwardRef,
	ViewEncapsulation,
	OnDestroy,
	ViewChild,
	ElementRef,
	Self,
	OnInit,
	Optional,
	HostListener
} from "@angular/core";
import { ControlValueAccessor, NgControl } from "@angular/forms";
import { IdService } from "../shared/services/id.service";
import { Observable } from "rxjs";

@Component({
	selector: "rbc-radio",
	template: `
		<div class="rbc-radio"
		(mouseout)="removeFocus()" #radioWrap>
			<input
				#radio
				class="rbc-radio-control"
				role="radio"
				[attr.aria-label]="value"
				[attr.aria-checked]="isChecked()"
				type="radio"
				[id]="id+'Radio'"
				[name]="name"
				[attr.name]="name"
				[disabled]="disabled"
				[attr.checked]="isChecked()"
				[value]="value"
				[checked]="isChecked()"
				[attr.value]="value"
				(change)="updateSelected()"
			/>
			<label
				[id]="id+'Label'"
				[for]="id+'Radio'"
				[ngClass]="{ disabled: disabled }"
				class="rbc-radio-label"
			>
			<rbc-icon
				[icon]="isChecked() ? 'dot-circle' : 'circle'"
				[attr.aria-hidden]="true"
				class="rbc-radio-icon">
				</rbc-icon>
				{{label}}
				<ng-content></ng-content>
			</label>

		</div>
	`,
	encapsulation: ViewEncapsulation.None,
	providers: [

	]
})
export class RadioComponent implements ControlValueAccessor, OnDestroy, OnInit {
	@Input() id: string;

	@Input() disabled: boolean | string;
	@Input() name: string;
	@Input() value: any;
	@Input() checked: any;
	@Input() label: any;
	@Output() radioUpdate = new EventEmitter();
	@Output() onChange = new EventEmitter();

	@ViewChild("radio", { static: false }) radioRef: ElementRef;
	@ViewChild("radioWrap", { static: false }) radioWrap: ElementRef;

	mouseoutObservable: Observable<any>;

	constructor(private idService: IdService, @Optional() @Self() private ngControl: NgControl) {
		this.id = idService.generate();
		ngControl.valueAccessor = this;
	}


	ngOnInit() {
		this.ngControl.control.valueChanges.subscribe(value => {
			// Check to ensure the value wasn't already set (Template driven forms)
			if(this.checked === value) return;
			this.writeValue(value);
		});
	}

	ngOnDestroy(): void {
		this.idService.remove(this.id);
	}

	// Function to call when the rating changes.
	change = (item) => {
	}

	onTouched = () => { };

	writeValue(obj: any): void {
		this.checked = obj;
		// this.onChange.emit(obj);
	}
	registerOnChange(fn: any): void {
		this.change = fn;
	}
	registerOnTouched(fn: any): void {
		this.onTouched = fn;
	}
	setDisabledState?(isDisabled: boolean): void {
		this.disabled = isDisabled;
	}

	isChecked() {
		return this.checked === this.value;
	}


	updateSelected() {
		this.checked = this.checked === this.value ? null : this.value;
		this.change(this.checked)
		this.onChange.emit(this.value);
		this.radioUpdate.emit({name: this.name, checked: this.value});
	}

	removeFocus() {
		this.radioRef.nativeElement.blur();
		this.mouseoutObservable = null;
	}
}
